export default __webpack_public_path__ + "static/media/expandir-menos.9460f829.svg";